import { readLegacyEnv } from './env';

// API configuration based on Vite environment variables.
export const API_BASE_URL = readLegacyEnv('VITE_API_BASE_URL', 'REACT_APP_API_BASE_URL', '/api');
export const FRONTEND_API_URL = readLegacyEnv(
  'VITE_FRONTEND_API_URL',
  'REACT_APP_FRONTEND_API_URL',
  '/api/frontend/v1'
);

/**
 * Helper function to build full API URLs
 * @param path - The API path (with or without leading slash)
 * @returns Complete API URL
 */
export const buildApiUrl = (path: string): string => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  // Remove trailing slash from base URL if present
  const baseUrl = FRONTEND_API_URL.endsWith('/') ? FRONTEND_API_URL.slice(0, -1) : FRONTEND_API_URL;
  
  return `${baseUrl}${normalizedPath}`;
};

/**
 * Helper function to build API URLs for different base endpoints
 * @param basePath - The base path (e.g., 'finix', 'review-app', 'rate')  
 * @param path - The specific API path
 * @returns Complete API URL
 */
export const buildSpecificApiUrl = (basePath: string, path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const baseUrl = FRONTEND_API_URL.endsWith('/') ? FRONTEND_API_URL.slice(0, -1) : FRONTEND_API_URL;
  
  return `${baseUrl}/${basePath}${normalizedPath}`;
};

// Export commonly used API endpoints
export const API_ENDPOINTS = {
  REVIEW_APP: {
    APPOINTMENT_DETAILS: (version: string, id: string) => buildApiUrl(`/review-app/appointment/details/${version}/${id}`),
    FEEDBACK_SUBMIT: () => buildApiUrl('/review-app/feedback/submit'),
    REVIEW_CLICK: () => buildApiUrl('/review-app/review/click/'),
    TRACK_LINK_OPEN: () => buildApiUrl('/review-app/track-link-open'),
    DASHBOARD: (locationIds: string, startDate: string, endDate: string) => 
      buildApiUrl(`/review-app/dashboard/${locationIds}/${startDate}/${endDate}`),
    GOOGLE_REVIEWS: (locationIds: string, startDate: string, endDate: string) => 
      buildApiUrl(`/review-app/google-reviews/${locationIds}/${startDate}/${endDate}`),
  },
  RATE: {
    CONFIG: () => buildApiUrl('/rate/rate-config/rate-message-custom-fields'),
    UPDATE_CONFIG: () => buildApiUrl('/review-app/rate-config'),
    FEEDBACK_DETAILS: (locationIds: string, startDate: string, endDate: string) => 
      buildApiUrl(`/rate/feedback/review_data/${locationIds}/${startDate}/${endDate}`),
    FEEDBACK_ACTIONS: () => buildApiUrl('/rate/feedback/actions'),
    GENERATE_REPLY: () => buildApiUrl('/rate/reputation/generate-review-reply-by-ai'),
    SEND_REPLY: () => buildApiUrl('/rate/reputation/create-review-reply'),
    SEARCH_CUSTOMERS: () => buildApiUrl('/rate/feedback/search-customers'),
  },
  PAYMENT: {
    TIP_SUBMIT: () => buildApiUrl('/finix/tip'),
    STRIPE_TIP_CHECKOUT_SESSION: () => buildApiUrl('/stripe/tips/checkout-session'),
  }
} as const;
